/**
 * FE ↔ BE contract for Copy Data realtime progress.
 * Align with BE before merge if event/path names differ — only change constants here.
 */

export const COPY_DATA_SIGNALR_EVENT = 'reloadCopyData' as const;

export const COPY_DATA_STATUS_PATH = '/v1/tenant/copydata-from-dashboard/status' as const;

/** BE đã có endpoint status — bật poll fallback khi SignalR miss. */
export const COPY_DATA_STATUS_POLL_ENABLED = true;

export type CopyDataStepKey =
  | 'mucTieuXuongCaKpis'
  | 'baoCaoKpis'
  | 'tiTrong'
  | 'actionPlan'
  | 'ipoo'
  | 'kpiChung'
  | 'baoCaoKpiChung';

export type CopyDataStepStatus = 'pending' | 'running' | 'done' | 'failed' | 'skipped';

export type CopyDataPhase = 'idle' | 'running' | 'complete' | 'failed';

export type CopyDataSignalPhase = 'start' | 'progress' | 'complete' | 'failed';

export const COPY_DATA_STEP_ORDER: CopyDataStepKey[] = [
  'mucTieuXuongCaKpis',
  'baoCaoKpis',
  'tiTrong',
  'actionPlan',
  'ipoo',
  'kpiChung',
  'baoCaoKpiChung',
];

export const COPY_DATA_STEP_LABELS: Record<CopyDataStepKey, string> = {
  mucTieuXuongCaKpis: 'Dữ liệu Mục tiêu, Xương cá, KPIs',
  baoCaoKpis: 'Dữ liệu báo cáo KPIs',
  tiTrong: 'Tỉ trọng',
  actionPlan: 'Action Plan',
  ipoo: 'Dữ liệu thư viện KPI IPOO',
  kpiChung: 'Dữ liệu KPI Chung',
  baoCaoKpiChung: 'Dữ liệu Báo cáo KPI Chung',
};

export type CopyDataStepState = {
  stepKey: CopyDataStepKey;
  status: CopyDataStepStatus;
  label: string;
};

export type CopyDataSignalPayload = {
  phase: CopyDataSignalPhase;
  jobId?: string;
  tuNam?: number;
  denNam?: number;
  stepKey?: CopyDataStepKey;
  stepStatus?: CopyDataStepStatus;
  percent?: number;
  message?: string;
  steps?: Array<{ stepKey: string; status: string }>;
};

export type CopyDataJobSnapshot = {
  jobId: string;
  tuNam: number;
  denNam: number;
  phase: CopyDataPhase;
  steps: CopyDataStepState[];
  percent: number;
  errorMessage?: string;
  minimized: boolean;
  t: number;
};
